import Transfer from '@/api/transfer'

export default {
  fetchPerPage: ({ commit, getters, rootState }, { page = 1 }) => {
    commit('changeLoading', { isLoading: true })
    return Transfer.fetchAll({ page })
      .then(({ data, pagination }) => {
        commit('collectionForPageFetched', {
          collectionForPage: data,
          pagination,
          scope: { page }
        })
        commit('changeLoading', { isLoading: false })
      })
      .catch(error => {
        commit('changeLoading', { isLoading: false })
        throw error
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/skiliko/transfers/actions.js